<template>
  
  <!-- Breadcrumb -->
  <div class="subtitle-container">
    <ul>
      <li class="breadcrumb d-inline">
        <a href="/home">Introdução</a>
      </li>
      <li class="breadcrumb d-inline">
        <span class="divider">
          <font-awesome-icon :icon="['fas', 'fa-angle-right']" />
        </span>
      </li>                        
      <li class="breadcrumb d-inline">
        <span>Registo</span>
      </li>
    </ul>
  </div>

  <!-- Page Title -->
  <div class="title-container">
    <h2 class="primary-title">Informações Gerais da Empresa</h2>
  </div>

  <!-- Form -->
  <div class="form">
    <form>
      <div class="row">
        <!--Q0.1 Designação social da Empresa -->
        <div class="col-md-12">
          <div
            class="input-wrapper"
            :class="{
              filled: Company_Name.val !== '',
              invalid: !Company_Name.isValid,
            }"
          >
            <input
              type="text"
              id="Company_Name"
              maxlength="100"
              v-model.trim="Company_Name.val"
              @blur="clearValidity('Company_Name')"
            />
            <label for="Company_Name">
              Designação social da Empresa (ou Grupo Empresarial, caso
              aplicável)
            </label>
            <p v-if="!Company_Name.isValid">Campo Obrigatório</p>
          </div>
        </div>
        <!--Q0.2 NIF -->
        <div class="col-md-12">
          <div
            class="input-wrapper"
            :class="{
              filled: Company_NIF.val !== null && Company_NIF.val.length > 0,
              invalid: !Company_NIF.isValid,
            }"
          >
            <input
              type="text"
              id="Company_NIF"
              maxlength="9"
              minlength="9"
              @input="formatNIF($event)"
              v-model.trim="Company_NIF.val"
              @blur="clearValidity('Company_NIF')"
            />
            <label for="Company_NIF">NIF</label>
            <p v-if="!Company_NIF.isValid">
              Campo deve ser numérico e conter 9 dígitos
            </p>
          </div>
        </div>
        <!--Q10 Nome de Contacto -->
        <div class="col-md-12">
          <div
            class="input-wrapper"
            :class="{
              filled: Contact_Name.val !== '',
              invalid: !Contact_Name.isValid,
            }"
          >
            <input
              type="text"
              id="Contact_Name"
              maxlength="100"
              v-model.trim="Contact_Name.val"
              @blur="clearValidity('Contact_Name')"
            />
            <label for="Contact_Name">Nome da pessoa de contacto</label>
            <p v-if="!Contact_Name.isValid">Campo Obrigatório</p>
          </div>
        </div>
        <!--Q11 Telefone de Contacto -->
        <div class="col-md-12">
          <div
            class="input-wrapper"
            :class="{
              filled: Contact_Phone.val !== '',
              invalid: !Contact_Phone.isValid,
            }"
          >
            <input
              type="text"
              id="Contact_Phone"
              maxlength="15"
              v-model.trim="Contact_Phone.val"
              @input="cleanPhoneInput('Contact_Phone')"
              @blur="clearValidity('Contact_Phone')"
            />
            <label for="Contact_Phone">Telefone da pessoa de contacto</label>
            <p v-if="!Contact_Phone.isValid">
              Campo deve ser preenchido com um contacto telefónico válido
            </p>
          </div>
        </div>
        <!--Q12 Email de Contacto -->
        <div class="col-md-12">
          <div
            class="input-wrapper"
            :class="{
              filled: Contact_Email.val !== '',
              invalid: !Contact_Email.isValid,
            }"
          >
            <input
              type="text"
              id="Contact_Email"
              maxlength="300"
              v-model.trim="Contact_Email.val"
              @blur="clearValidity('Contact_Email')"
            />
            <label for="Contact_Email">Email da pessoa de contacto</label>
            <p v-if="!Contact_Email.isValid">
              Campo deve ser preenchido com um email válido
            </p>
          </div>
        </div>

        <!-- Footer -->
        <div class="col-12 form-footer">
          <!-- RGPD -->
          <div class="col-lg-6">
            <div class="radio-wrapper" :class="{ invalid: !rgpd.isValid }">
              <input
                id="rgpd-concordo"
                name="rgpd"
                type="checkbox"
                @click="toggleRGPD"
                :checked="rgpd.val"
                :class="{ checked: rgpd.val }"
              />
              <label for="rgpd-concordo"></label>
              <span>
                Li e aceito a
                <a @click="showRGPD = true">Política de Privacidade</a>.
              </span>
              <p v-if="!rgpd.isValid">Campo Obrigatório</p>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="d-flex justify-content-end">
              <button
                class="button"
                type="submit"
                @click.prevent="submitForm(true)"
              >
                <span>
                  Avançar
                </span>
              </button>
            </div>
          </div>

          <!-- End Footer -->

          <div class="glossary">
            <!-- When pop-up open create overlay outside glossary to click and close -->
            <div
              v-if="showRGPD"
              class="glossary-overlay"
              @click="showRGPD = false"
            ></div>
            <!-- Pop-up content to show when open -->
            <div v-if="showRGPD" class="glossary-popup">
              <div class="glossary-content">
                <!-- X button to close pop-up -->
                <span class="close" @click="showRGPD = false">&times;</span>
                <!-- Title -->
                <h3 class="mb-3">Aviso de Privacidade</h3>
                <div class="glossary-list">
                  <!-- Text -->
                  <p>
                    A APQuímica compromete-se a assegurar a total
                    confidencialidade da informação individual recebida, nos
                    termos da legislação em vigor.
                  </p>
                  <p>
                    Em concreto, toda a informação que resulte do preenchimento da
                    presente ferramenta de auto-diagnóstico será exclusivamente
                    utilizada para a construção, execução e acompanhamento /
                    monitorização do Roteiro de Neutralidade Carbónica da
                    Indústria Química Portuguesa 2050 (RNCIQ PT 2050), sendo o seu
                    acesso restrito à equipa técnica da Associação e a consultores
                    que a assistam para esta finalidade, desde que igualmente ao
                    abrigo de uma relação contratual com a APQuímica que
                    salvaguarde o estrito cumprimento do mesmo nível de
                    confidencialidade.
                  </p>
                  <p>
                    Para efeitos de divulgação no quadro do RNCIQ PT 2050, a
                    informação recebida será apenas utilizada em formato global
                    agregado, assegurando a não identificação de quaisquer dados
                    individuais que a componham. A partilha e/ou divulgação de
                    quaisquer dados individuais obtidos pelo preenchimento da
                    presente ferramenta de auto-diagnóstico é expressamente
                    proibida, excepto nos casos e condições em que tal seja
                    expressamente autorizado pelo detentor dos dados em causa.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- FinalCheck -->
          <div class="glossary">
            <!-- When pop-up open create overlay outside glossary to click and close -->
            <div
              v-if="showFinalCheck"
              class="glossary-overlay"
              @click.prevent="handleFinalCheckPopup"
            ></div>
            <!-- pop-up content to show when open -->
            <div v-if="showFinalCheck" class="glossary-popup">
              <div class="glossary-content">
                <!-- X button to close pop-up -->
                <span class="close" @click.prevent="handleFinalCheckPopup"
                  >&times;</span
                >
                <!-- Title -->
                <h3 class="mb-3">Empresa já registada</h3>
                <!-- Text -->
                <p>
                  Já existe um questionário preenchido para a empresa
                  selecionada (NIF {{ Company_NIF.val }}) no ano corrente.
                </p>
                <p>
                  Tem a certeza que pretende avançar com o preenchimento de um
                  novo questionário?
                </p>
                <!-- Buttons -->
                <div class="submission-check-buttons-container">
                  <button
                    class="btn btn-cancel"
                    @click.prevent="handleFinalCheckPopup"
                  >
                    Cancelar
                  </button>
                  <button class="btn" @click.prevent="submitForm(false)">
                    Avançar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  emits: ['save-data', 'change-final-check'], // emits method to save the data in the backend and to display the pop up
  props: ['showFinalCheck'], // receives data propertie that shows/hides the pop up

  created() {
    if (!localStorage.getItem('companyInformation')) {
      const companyInfo = {
        Company_Id: NaN,
        Company_Name: '',
        Company_NIF: '',
        Contact_Name: '',
        Contact_Phone: '',
        Contact_Email: '',
      };
      localStorage.setItem('companyInformation', JSON.stringify(companyInfo));
    }
    // get the data from the localStorage
    this.loadDataFromLocalStorage();

    // if we are mounting to show the pop up
    if (this.showFinalCheck) {
      // we manually put rgpd to true, but only because the user checked it and submitted
      this.toggleRGPD(); // since we reset the state when emmiting the submit we need to re toggle it, but we never toggle it without the user doing it
    }
  },

  data() {
    return {
      showRGPD: false, // controls the rgpd pop up
      Company_Name: {
        // for every data propertie we have:
        val: '', // the value
        isValid: true, // if it is valid or not
      },
      Company_NIF: {
        val: '',
        isValid: true,
      },
      Contact_Name: {
        val: '',
        isValid: true,
      },
      Contact_Phone: {
        val: '',
        isValid: true,
      },
      Contact_Email: {
        val: '',
        isValid: true,
      },
      rgpd: {
        val: false,
        isValid: true,
      },
      invalidFields: [], // fields that are invalid
    };
  },
  watch: {
    'Company_Name.val': function (newValue) {
      this.updateLocalStorage('Company_Name', newValue);
    },
    'Company_NIF.val': function (newValue) {
      this.updateLocalStorage('Company_NIF', newValue);
    },
    'Contact_Name.val': function (newValue) {
      this.updateLocalStorage('Contact_Name', newValue);
    },
    'Contact_Phone.val': function (newValue) {
      this.updateLocalStorage('Contact_Phone', newValue);
    },
    'Contact_Email.val': function (newValue) {
      this.updateLocalStorage('Contact_Email', newValue);
    },
  },
  methods: {
    loadDataFromLocalStorage() {
      const companyInfo =
        JSON.parse(localStorage.getItem('companyInformation')) || {};
      this.Company_Name.val = companyInfo.Company_Name || '';
      this.Company_NIF.val = companyInfo.Company_NIF || '';
      this.Contact_Name.val = companyInfo.Contact_Name || '';
      this.Contact_Phone.val = companyInfo.Contact_Phone || '';
      this.Contact_Email.val = companyInfo.Contact_Email || '';
    },

    // Method to update local storage with the current data
    updateLocalStorage(field, value) {
      const companyInfo =
        JSON.parse(localStorage.getItem('companyInformation')) || {};
      companyInfo[field] = value;
      localStorage.setItem('companyInformation', JSON.stringify(companyInfo));
    },

    // format nif so that it does not accept non numeric values
    formatNIF(event) {
      let value = event.target.value;
      // Remove any non-digit characters

      value = value.replace(/\D/g, '');
      // Update the item.Postal_Code with the formatted value

      this.Company_NIF.val = value;
    },

    cleanPhoneInput(field) {
      // Get the current value
      let value = this[field].val;
      // Allow '+' only at the beginning
      if (value.startsWith('+')) {
        // Remove all characters that are not digits (0-9) or the first '+'
        value = '+' + value.slice(1).replace(/[^0-9]/g, '');
      } else {
        // If it doesn't start with '+', remove any '+' and keep only digits
        value = value.replace(/\+/g, '').replace(/[^0-9]/g, '');
      }
      // Update the value with the sanitized input
      this[field].val = value;
    },

    // Toggle the RGPD message
    toggleRGPD() {
      this.rgpd.val = !this.rgpd.val;
      this.clearValidity('rgpd');
    },

    // Clear the error message when the user changes the input
    clearValidity(input) {
      this[input].isValid = true;
    },

    // Validate if the inputs are valid
    validateForm() {
      this.formIsValid = true;
      if (this.Company_Name.val === '') {
        this.Company_Name.isValid = false;
        this.formIsValid = false;
      }

      if (!this.Company_NIF.val || this.Company_NIF.val.length !== 9) {
        this.Company_NIF.isValid = false;
        this.formIsValid = false;
      }

      if (this.Contact_Name.val === '') {
        this.Contact_Name.isValid = false;
        this.formIsValid = false;
      } // check if the phone is valid

      if (
        this.Contact_Phone.val === '' ||
        !/^\+?[1-9]\d{8,13}$/.test(this.Contact_Phone.val)
      ) {
        this.Contact_Phone.isValid = false;
        this.formIsValid = false;
      } // check if the email is valid

      if (
        this.Contact_Email.val === '' ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.Contact_Email.val)
      ) {
        this.Contact_Email.isValid = false;
        this.formIsValid = false;
      }

      if (!this.rgpd.val) {
        this.rgpd.isValid = false;
        this.formIsValid = false;
      }
    },

    // method to activate pop up
    handleFinalCheckPopup() {
      this.$emit('change-final-check');
    },

    // submit company data
    submitForm(check) {
      // validate form
      this.validateForm();
      if (!this.formIsValid) {
        return;
      }

      // if valid and this is a first submit, we need to check if company exists
      if (check) {
        const formData = {
          name: this.Company_Name.val,
          nif: this.Company_NIF.val,
          contactname: this.Contact_Name.val,
          contactphone: this.Contact_Phone.val,
          contactemail: this.Contact_Email.val,
          isnifcheck: true, // we send ischeck as true to perform check in the backend
        };
        this.$emit('save-data', formData);
      } else {
        const formData = {
          name: this.Company_Name.val,
          nif: this.Company_NIF.val,
          contactname: this.Contact_Name.val,
          contactphone: this.Contact_Phone.val,
          contactemail: this.Contact_Email.val,
          isnifcheck: false,
        };
        this.$emit('save-data', formData);

        // if its not a check, and its a final submit
      }
    },
  },
};
</script>
